import { formatRatingAverage } from 'helpers/formatters'

/**
 * Prepares the list of features to display by combining top-rated features
 * with unique features when needed (up to 3 total)
 */
export const prepareFeaturesToDisplay = (topFeatures, uniqueFeatures) => {
  const result = []
  const availableUniqueFeatures = [...uniqueFeatures]

  // Try to fill up to 3 slots
  for (let i = 0; i < 3; i++) {
    // First try to use a top feature with ratings
    if (topFeatures[i]?.cnt_rating) {
      result.push(topFeatures[i])
    }
    // If no top feature available, try to use a unique feature
    else if (availableUniqueFeatures.length > 0) {
      result.push({ name: availableUniqueFeatures.shift() })
    }
    // If neither is available, that slot stays empty
  }

  return result.filter(feature => feature.name)
}

export const formatRating = rating =>
  formatRatingAverage(rating).includes('.0') ? formatRatingAverage(rating).split('.')[0] : formatRatingAverage(rating)
